import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { AuthGuard } from '@/components/auth-guard';
import { TasksPage } from '@/features/groups/components';

function TasksRoute(): ReactNode {
  return (
    <AuthGuard>
      <TasksPage />
    </AuthGuard>
  );
}

export const Route = createFileRoute('/tasks')({
  component: TasksRoute,
});
